module.exports = __webpack_public_path__ + "img/img-970703.jpg";